<template>
  <modal-wrapper
    v-if="domain"
    :shown="shown"
    title="Are you sure you want to delete this domain?"
    @close-modal="$emit('close-modal')"
  >
    <p class="text-white">
      <strong>{{ domain.name }}</strong>
    </p>

    <button class="btn btn-danger btn-lg modal-action-button danger" :disabled="processing" @click="onDeleteClick">
      Delete
    </button>

    <modal-processing-indicator v-if="processing"></modal-processing-indicator>

    <div v-if="errorMessage" v-html="errorMessage" class="text-danger mt-5"></div>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '../../modal/ModalWrapper';
import ModalProcessingIndicator from '../../modal/ModalProcessingIndicator';
import {handleActionModalResponse} from '../../../utility/modal/handleActionModalResponse';
import {deleteEmailDomain} from '../../../utility/api/vessel/deleteEmailDomain';
import {createEmailDomain} from "../../../utility/api/vessel/createEmailDomain";

export default {
  name: 'delete-email-domain-modal',
  components: {ModalWrapper, ModalProcessingIndicator},
  data() {
    return {
      processing: false,
      errorMessage: null,
    };
  },
  props: {
    domain: {
      type: Object,
      required: true,
    },
    shown: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    shown(shown, previousShown) {
      if (!shown && previousShown) {
        this.processing = false;
        this.domain = null;
      }
    },
    domain() {
      this.errorMessage = null;
    },
  },
  methods: {
    async onDeleteClick() {
      this.processing = true;

      try {
        const response = await deleteEmailDomain(this.domain.id);
        if (handleActionModalResponse(response, '/account/mailer/')) {
          this.$emit('close-modal');
        }
      } catch (error) {
          this.errorMessage = error.message;
      }
      this.processing = false;
    },
  },
};
</script>
